(function() {
    'use strict';
 
 a3_pilot_reports.filter('messageFilter', messageFilter);
 
    /**
    * @memberof PilotReports
    * @ngdoc filter
    * @name messageFilter
    * @description 
    *   Filters messages in order to show only the unread.
    * @ngInject
    */
function messageFilter () {
	return function(input,isEnable) {
				if (isEnable) {
						var result = []; 
						for (var i = 0; i<input.length; i++) {
								if(input[i].ReadDt==null){
										result.push(input[i]);
								}
						}
						return result;
				} 
				else{
						return input;
				}
		};
} 
		
 
 })();   